export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    window.scrollTo(0, 0);

    const hash = window.location.hash;

    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        const headerElement = document.querySelector('#header');
        if (element) {
          const headerHeight = headerElement?.clientHeight || 0;
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - headerHeight,
            behavior: 'smooth',
          });
        }
      }, 1250);
    }
  });
});
